import { Badge } from "@devhop/ui";
import { useQiProductAvailabilityQuery } from "../api/queries";

export function QiLineAvailabilityBadge({
  productId,
  branchId,
  neededQty,
}: {
  productId?: string;
  branchId?: string;
  neededQty?: number;
}) {
  const availability = useQiProductAvailabilityQuery({
    productId,
    branchId,
    enabled: Boolean(productId && branchId),
  });

  if (!productId || !branchId) return null;
  if (availability.isLoading) {
    return (
      <Badge variant="outline" className="mt-1 text-xs font-normal">
        ກຳລັງໂຫຼດສຕັອກ...
      </Badge>
    );
  }
  if (!availability.data) return null;

  const { onHand, reserved, available } = availability.data;
  const insufficient =
    neededQty != null && neededQty > 0 && available + 0.0001 < neededQty;

  return (
    <Badge
      variant={insufficient ? "destructive" : "outline"}
      className="mt-1 text-xs font-normal tabular-nums"
    >
      {insufficient ? "ບໍ່ພໍ" : "ພ້ອມ"} · ມີ {available.toLocaleString()} (on-hand{" "}
      {onHand.toLocaleString()}, reserved {reserved.toLocaleString()})
    </Badge>
  );
}
